import React from 'react'
import shallowCompare from 'react-addons-shallow-compare';
import RichTextEditor from '../../../../components/Form/RichTextEditor'
import MediaViewer from '../../../../components/MediaViewer'
import './KpDashboard.css'
import ChartContainer from '../../../../components/Dashboard/ChartContainer'
import ShortCard from '../../../../components/Dashboard/ShortCard'
import Charts from '../../../../components/Dashboard'
import history from '../../../../history'
import FilePreviewAndDownload from '../../../../components/filePreviewAndDownload'
import {translateName} from "../../../../utils/i18n";
import withQuery from "with-query";
import {PLATFORM_MEDIA_ACCESS_ID} from "../../../../utils/network";

function truncateString(str, num) {
    if (str.length <= num) {
        return str
    }
    return str.slice(0, num) + '...'
}

class KpDashboard extends React.Component {

    componentDidMount() {
        const { modelId, groupModelId, groupModel, groupId, dashboardElements, fetchDashboardData, fetchPlatformMediaElements } = this.props
        fetchPlatformMediaElements(modelId, groupId, groupModel.profiles)
        dashboardElements && fetchDashboardData(dashboardElements, groupModelId, modelId)
    }

    componentDidUpdate(prevProps) {
        const { modelId, groupModelId, groupModel, groupId, dashboardElements, fetchDashboardData, fetchPlatformMediaElements } = this.props
        if(prevProps.groupModelId !== this.props.groupModelId) {
            fetchPlatformMediaElements(modelId, groupId, groupModel.profiles)
            dashboardElements && fetchDashboardData(dashboardElements, groupModelId, modelId)
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return shallowCompare(this, nextProps, nextState);
    }

    render() {
        const {
            modelId,
            groupModel,
            groupModelId,
            dashboardElements,
            mediaElements,
            elementsAreFetching,
            dashboardDataIsFetching,
            dashboardData,
            t,
            language,
            device
        } = this.props

        const getContainerClass = (width) => {
            switch (width) {
                case 1:
                    return "col-sm-12 col-md-12 col-lg-12"
                case 1/2:
                    return "col-sm-6 col-md-6 col-lg-6"
                default:
                    return "col-sm-6 col-md-4 col-lg-4"
            }
        }

        const groupedRows = []
        let i = 0

        while (i < mediaElements?.length) {
            const current = mediaElements[i]

            if (current.widthOption.id === 'full') {
                // Full-width element → its own row
                groupedRows.push([current])
                i++
            } else {
                // Half-width element → pair with another half-width if available
                const next = mediaElements[i + 1]
                if (next && next.widthOption.id !== 'full') {
                    groupedRows.push([current, next])
                    i += 2
                } else {
                    groupedRows.push([current])
                    i++
                }
            }
        }

        return ['S', 'I', 'U', 'R', 'C'].includes(modelId) && !elementsAreFetching ? (
            <div className="KpDashboard-container container-fluid">
                <div className="row">
                {
                    dashboardElements.map((element, index) => {
                        return element.type === 'shortCard'
                            ? <ShortCard
                                key={element.id}
                                title={element.name}
                                language={language}
                                subTitle={dashboardData[element.id] && dashboardData[element.id].subTitle}
                                data={dashboardData[element.id] && dashboardData[element.id].data}
                                isFetching={dashboardDataIsFetching[element.id]}
                                suffix={element.suffix}
                                dates={dashboardData[element.id] && dashboardData[element.id].dates}
                                width={element.width}
                                link={{title: element.link.title, path: `/business/${groupModelId}/${element.link.path}`}}
                                t={t}
                            />
                            : element.type === 'video'
                                ? <div className={`videoContainer ${getContainerClass(element.width)}`}>
                                    <video
                                        src={withQuery(`/video/${dashboardData[element.id] && dashboardData[element.id].link}`, {accessId: PLATFORM_MEDIA_ACCESS_ID})}
                                        poster={withQuery(`/image/${dashboardData[element.id] && dashboardData[element.id].poster}`, {accessId: PLATFORM_MEDIA_ACCESS_ID})}
                                        style={{outline: 'none', borderRadius: '4px'}}
                                        width='100%'
                                        controls
                                        controlsList='nodownload'
                                    />
                                </div>
                                : <ChartContainer
                                    key={element.id || element._id}
                                    defaultTitle={element.name}
                                    title={dashboardData[element.id || element._id] && dashboardData[element.id || element._id].title}
                                    Component={Charts[element.type]}
                                    width={element.width && element.width}
                                    className={`dashboard_${index}`}
                                    subTitle={dashboardData[element.id || element._id] && dashboardData[element.id || element._id].subTitle}
                                    data={dashboardData[element.id || element._id] && dashboardData[element.id || element._id].data}
                                    dataKeys={dashboardData[element.id || element._id] && dashboardData[element.id || element._id].dataKeys}
                                    isFetching={dashboardDataIsFetching[element.id || element._id]}
                                    keys={element.keys && element.keys}
                                    colors={element.colors}
                                    sum={element.sum}
                                    total={dashboardData[element.id || element._id] && dashboardData[element.id || element._id].total}
                                    sumColor={element.sumColor}
                                    absolute={element.absolute}
                                    axisHeight={element.axisHeight}
                                    useColorsByCashier={element.useColorsByCashier}
                                    useColorsByStore={element.useColorsByStore}
                                    suffix={element.suffix && element.suffix}
                                    t={t}
                                    language={language}
                                />
                    } )
                }
                </div>
                <div>
                    {
                        groupedRows?.length > 0 && groupedRows.map(row => {
                            return <div className="row">
                                {
                                    row.map((mediaElement, index) => {
                                        const widthParams = mediaElement.widthOption.id === 'full' ? "col-sm-12 col-md-12 col-lg-12" : "col-sm-12 col-md-6 col-lg-6"
                                        const articleTitleStyle = device !== "mobile" ? {whiteSpace: 'nowrap'} : {}
                                        const groupSelectedColor = groupModel.selectedColor ? {color: groupModel.selectedColor} : {}
                                        const tagsColorStyles = groupModel.selectedColor ? {color: groupModel.selectedColor, borderColor: groupModel.selectedColor} : {}
                                        return (
                                            <div className={widthParams} style={{padding: '0 5px'}}>
                                                <div className="MediaContainer" style={{flex: 2, margin: '5px'}}>
                                                    <div className="Article-container">
                                                        <div className="Article-header">
                                                            <div className="Article-title-block"
                                                                 style={{fontSize: '25px', ...articleTitleStyle, ...groupSelectedColor}}>
                                                                <div className="Article-title" onClick={() => {
                                                                    history.push(`/business/${groupModelId}/communication/m-${modelId}-mediaBaseUser/${mediaElement.id}`)
                                                                }}>
                                                                    {translateName(mediaElement.title, language)}
                                                                </div>
                                                                {
                                                                    mediaElement.fileType === 'doc' && mediaElement.filesToShowInHomePage.length >= 1 &&
                                                                    (<FilePreviewAndDownload
                                                                        file={mediaElement.filesToShowInHomePage[0]}
                                                                        files={mediaElement.filesToShowInHomePage}
                                                                        language={language}
                                                                        groupModel={groupModel}
                                                                        accessId={PLATFORM_MEDIA_ACCESS_ID}
                                                                        forceDisplayPreviewButton={true}
                                                                        //noDownload={false}
                                                                        showDownloadMenu={true}
                                                                    >
                                                                    </FilePreviewAndDownload>)
                                                                }
                                                            </div>
                                                            {
                                                                mediaElement.showTags && (
                                                                    <div className='tagsForDocuments'
                                                                         style={groupSelectedColor}>
                                                                        {mediaElement.tags.map(tag => <span
                                                                            style={tagsColorStyles}
                                                                            className="Article-tag">{translateName(tag.name, language)}</span>)}
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                        {
                                                            ['img', 'vid'].includes(mediaElement.fileType) && mediaElement.filesToShowInHomePage.length >= 1 && (
                                                                <div className="Article-image">
                                                                    <MediaViewer
                                                                        key={index} noThumbnail={true} path="mediaElements"
                                                                        data={{mediaElements: mediaElement.filesToShowInHomePage}}
                                                                        containerStyle={{borderRadius: 0}}
                                                                        accessId={PLATFORM_MEDIA_ACCESS_ID}
                                                                    />
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            ['doc'].includes(mediaElement.fileType) && mediaElement.filesToShowInHomePage.length >= 1 && mediaElement.imagesForFiles.length === 1 && (
                                                                <div className="Article-image">
                                                                    <MediaViewer
                                                                        key={index} noThumbnail={true} path="mediaElements"
                                                                        data={{mediaElements: mediaElement.imagesForFiles}}
                                                                        containerStyle={{borderRadius: 0}}
                                                                        accessId={PLATFORM_MEDIA_ACCESS_ID}
                                                                    />
                                                                </div>
                                                            )
                                                        }
                                                            <div className="Article-text">
                                                                {
                                                                    mediaElement.showDescription && <RichTextEditor
                                                                        applyMinHeight={false} key={index}
                                                                        value={truncateString(mediaElement.description, mediaElement.widthOption.id === 'full' ? 200 : 120)}
                                                                        t={t} initialValue readOnly={true}
                                                                    />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {index + ((device === "mobile" || (mediaElements.length % 2 !== 0)) ? 1 : 2) < mediaElements.length &&
                                                    <hr className="Article-separator"/>}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        })
                    }
                    {
                        device !== "mobile" && mediaElements && !!mediaElements.filter(elem => elem.includedInLatestNewsList).length && (
                            <div className="MediaContainer mediaLinksGroup"
                                 style={{flex: 1, margin: '5px', height: 'fit-content'}}>
                                <div className="mediaLinksGroup-title">Fil d'actualités</div>
                                {
                                    mediaElements.filter(elem => elem.includedInLatestNewsList).map(mediaElement => {
                                        return <div
                                            className="mediaLink"
                                            onClick={() => {
                                                history.push(`/business/${groupModelId}/communication/m-${modelId}-mediaBaseUser/${mediaElement.id}`)
                                            }}
                                        >
                                            {mediaElement.title}
                                        </div>
                                    })
                                }
                            </div>
                        )
                    }
                </div>
            </div>
        ) : (
            <div className="KpDashboard-container container-fluid"/>
        )
    }
}

export default KpDashboard
